import {all, call, put, takeLatest} from '@redux-saga/core/effects';
import {fromResult, Loading} from 'Core/models/Async';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import {UserUsernameApi} from 'Users/api';
import {
  changeEmail,
  recoverUsername,
  UserEmailRecoveryAddress,
  UsernameRecoveryActionTypes,
} from 'Users/ducks/userRecovery';
import axiosInstance from 'Shared/utilities/axiosInstance';

const UsernameRecoveryApi = new UserUsernameApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

function* recoverUsernameApi(action: ReturnType<typeof recoverUsername>) {
  yield put(changeEmail(UserEmailRecoveryAddress.email(new Loading())));

  const recoverUsernameApiCall = (email: string) =>
    UsernameRecoveryApi.userUsernameRecoverUsername(email, '1', getAxiosConfig(undefined)).then(handleResponse);

  yield call(recoverUsernameApiCall, action.payload.email.address);

  yield put(changeEmail(UserEmailRecoveryAddress.recoveryEmailSent(fromResult({}))));
}

function* recoverUsernameSaga() {
  yield takeLatest(UsernameRecoveryActionTypes.RECOVER_USERNAME, recoverUsernameApi);
}

export default function*() {
  return yield all([recoverUsernameSaga()]);
}
